import { nbsp } from "./util.js";

/**
 * Returns amount formatter function(s) and the default currency for a given locale.
 *
 * The default currency is a valid ISO 4217 currency code.
 *
 * @param {import("@borealis/locale-common").NMPLocale} locale
 * @return {{currencyCode: import('./format.js').CurrencyCode, amountFormatters: *}}
 */
export const getAmountFormatting = (locale) => {
	const { amountFormatters } = locales[locale];
	const currencyCode = /** @type {import('./format.js').CurrencyCode} */ (
		Object.keys(amountFormatters || {})[0]
	);
	return {
		amountFormatters,
		currencyCode,
	};
};

const locales = {
	nb: {
		amountFormatters: {
			NOK: (num) => num + nbsp + "kr",
		},
	},
	sv: {
		amountFormatters: {
			SEK: (num) => num + nbsp + "kr",
		},
	},
	da: {
		amountFormatters: {
			DKK: (num) => num + nbsp + "kr.",
		},
	},
	fi: {
		amountFormatters: {
			EUR: (num) => num + nbsp + "€",
		},
	},
	en: {
		amountFormatters: {
			EUR: (num) => num + nbsp + "€",
		},
	},
};
